import { createFileRoute } from '@tanstack/react-router';

import { FeesPage } from '@/features/profiles/fees-page';

export const Route = createFileRoute('/_app/org/$orgId/fees')({ component: OrgRoute });

function OrgRoute() {
  const { orgId } = Route.useParams();
  return <FeesPage orgId={orgId} />;
}
